import { AssetType } from "shared/enums/AssetType";
import { ApiFieldAsset } from "shared/types/ApiFieldAsset";
import React from "react";
import { DropzoneState } from "react-dropzone";
import { AssetUploadErrorCodeType } from "shared/form/types";
import I18n from "../../../types/I18n";

export interface AssetUploadProps {
  name: string;
  assetType: AssetType;
  assetUploadType: AssetUploadType;
  registrationId: string;
  registrationParticipantId?: string;
  uploadedAssets: Array<ApiFieldAsset>;
  disabled?: boolean;
  onAssetUpload: (asset: ApiFieldAsset) => void;
  onAssetUploadError?: (errorCode: AssetUploadErrorCodeType) => void;
  onAssetRemove?: (assetId: string) => void;
  customRenderer?: (props: CustomRendererType) => React.ReactNode;
  assetConfig?: AssetConfig;
  hasError: boolean;
  defaultAsset?: ApiFieldAsset;
  aspectRatioRestriction?: AspectRatioRestrictionType;
  disableImagePreview?: boolean;
  browseUploadCustomCopyKey?: keyof I18n;
  recommendedCustomCopy?: string;
  recommendedCustomCopyKey?: keyof I18n;
}

export interface CustomRendererType {
  disabled?: boolean;
  assetConfig?: AssetConfig;
  assetUploadType: AssetUploadType;
  uploadedAssets: Array<ApiFieldAsset>;
  dropzoneState?: DropzoneState;
  removeAsset?: (assetId: string) => void;
  uploadSelectedAsset?: (asset: SelectedAssetType) => void;
  hasError?: boolean;
  defaultAsset?: ApiFieldAsset;
  disableImagePreview?: boolean;
  browseUploadCustomCopyKey?: keyof I18n;
  recommendedCustomCopy?: string;
  recommendedCustomCopyKey?: keyof I18n;
}

export enum AssetUploadType {
  FILE = "FILE",
  IMAGE = "IMAGE",
  BOTH = "BOTH"
}

export enum AssetInputMode {
  SINGLE = "SINGLE",
  MULTI = "MULTI"
}

export interface AssetConfig {
  dimension: DimensionType;
  aspectRatio: string;
  maxSize: number; // IN KB
}

export interface DimensionType {
  height: number;
  width: number;
  minWidth?: number;
  maxWidth?: number;
  maxHeight?: number | string;
}

export interface SelectedAssetType {
  name?: string;
  asset?: File;
}

export enum AspectRatioRestrictionType {
  /**Only image with recommended dimension will be allowed */
  STRICT_DIMENSION = "STRICT_DIMENSION",
  /**Image with incorrect aspect ratio will not get uploaded */
  ERROR = "ERROR",
  /**Image with incorrect aspect ratio will get uploaded and warning message will be displayed */
  WARNING = "WARNING",
  /**ignore aspect ratio validation */
  NONE = "NONE",
  /** only image with recommended min width & max height will get uploaded */
  STRICT_MIN_WIDTH_MAX_HEIGHT = "STRICT_MIN_WIDTH_MAX_HEIGHT",
  /** only image with recommended max width will get uploaded */
  STRICT_MAX_WIDTH = "STRICT_MAX_WIDTH"
}
